
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Thumbnail, Panel, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import MarketingBlock from '../../common/content/MarketingBlock.js';

import color_01 from '../../../assets/img/album/color_01.jpg';
import color_02 from '../../../assets/img/album/color_02.jpg';

import img_01 from '../../../assets/img/album/tracy_01.jpg';
import img_02 from '../../../assets/img/album/tracy_02.jpg';
import img_03 from '../../../assets/img/album/tracy_03.jpg';
import img_04 from '../../../assets/img/album/tracy_04.jpg';
import img_05 from '../../../assets/img/album/tracy_05.jpg';
import img_06 from '../../../assets/img/album/tracy_06.jpg';
import img_07 from '../../../assets/img/album/tracy_07.jpg';
import img_08 from '../../../assets/img/album/tracy_08.jpg';
import img_09 from '../../../assets/img/album/tracy_09.jpg';

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class Album extends React.Component {
	render() {
		return (
			<div id="Album">
				<Grid>
					<div className="well">
		    		<Row>
		    			<Col xs={12} md={12}>
		    				<center>
			    				<MarketingBlock header="Tracy Steven Brown">
			    					<span className="lead text-muted">A brief collection of photos during my senior academic and <a href="https://en.wikipedia.org/wiki/Informatics">informatics</a> tour at the <a href="http://www.arizona.edu">University of Arizona</a> along with some quotations I find inspirational.<br/><br/>My most recent affiliation was with the prestigious University of Arizona (UA) Clinical Bioinformatics and Biostatistics Core (CB2) alongside Lussier Research Group (Lussier Lab), the UA BIO5 Institute initiative, and the UA Cancer Center as a Senior Appointed Professional and member of the office of Senior Vice President of Health Sciences.</span>
			    				</MarketingBlock>
		    				</center>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col md={2}>&nbsp;</Col>
		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={color_01}>
				        	<p className="text-justify" style={fontSize}>
				        		"Like a line divided into two unequal sections ... in one subsection, the soul, using as images the things that were imitated before, is forced to investigate from hypotheses, proceeding not to a first principle but to a conclusion." [1]
				        	</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={color_02}>
				          <p className="text-justify" style={fontSize}>
				          	"In the other subsection, however, it makes its way to a first principle that is not a hypothesis, proceeding from a hypothesis but without the images used in the previous subsection, using forms themselves and making its investigation through them." [1]
				          </p>
		    				</Thumbnail>
		    			</Col>
		    			<Col md={2}>&nbsp;</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_01}>
				          <p className="text-justify" style={fontSize}>"The computer network appears as a godsend in providing forums for people to gather in surprisingly personal proximity ... where there is freedom to change at whim, to become liquid." [2]</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_05}>
				          <p className="text-justify" style={fontSize}>"... where 'his halcyon days brought forth the arts of peace' with 'a soaring reputation as unfailingly reliable' and the House of Fame sends word to the Trojans that Greeks are approaching their shores; where an increasingly embattled president was willing to trust." [3,7]</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_06}>
				          <p className="text-justify" style={fontSize}>"... exempt from military service, so they're able to live in comfort, if not in luxury, and be happy, if not exactly famous or glorious ... I doubt if anyone has ever heard of them." [4]</p>
		    				</Thumbnail>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_04}>
				          <p className="text-justify" style={fontSize}>"the soul can preserve its own clear sky and calm voyage by not assessing pain as an evil. Every judgement, every impulse, desire and rejection is within the soul, where nothing evil can penetrate." [5]</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_03}>
				          <p className="text-justify" style={fontSize}>"... there is conditional commitment and the power of adaptation. The mind adapts and turns round any obstacle to action to serve its objective: a hindrance to a given work is turned to its furtherance, an obstacle in a given path becomes an advance." [5]</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_02}>
				          <p className="text-justify" style={fontSize}>"In these aphorisms, pithy definitions, reflections, reminders, and exhortations ... give up books and reading in favour of the more serious enterprise of self-mastery and self-improvement." [5]</p>
		    				</Thumbnail>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_07}>
				          <p className="text-justify" style={fontSize}>"We're trying to have a really big impact ... if the rules are such that you can't make progress, then you have to fight the rules." [6] (Musk) - those are the gates of heaven in the background. [see: <a href="/KarnaRam">Karna-Ram</a>]</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_08}>
				          <p className="text-justify" style={fontSize}>"Let us not forget that we are fighting for peace, and for the welfare of mankind. We are not fighting for conquest. There is not one piece of territory or one thing of a monetary nature that we want ... [only] peace and prosperity for the world as a whole." [7] (Truman)</p>
		    				</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={4}>
		    				<Thumbnail className="img-responsive center-block img-fluid albumPanel" src={img_09}>
				          <p className="text-justify" style={fontSize}>"...Lead by example and turn away from an uncontrolled race that could only end in ever-greater heights of unimaginable destructiveness ... [be] stunningly swift." [7] (Kennan)</p>
		    				</Thumbnail>
		    			</Col>
		    		</Row>
		    	</div>
				</Grid>

				<Panel>
					<p>[1] Plato, J.M. Cooper, and D.S. Hutchinson, Complete works. 1997, Indianapolis, Ind.: Hackett Pub. xxx, 1808 p.</p>
					<p>[2] Benedikt, M., Cyberspace: first steps. 1991, Cambridge, Mass.: MIT Press. viii, 436p., 8 p. of plates. (pages 73, 227)</p>
	        <p>[3] Ovid and J.L. Lincoln, Selections from the poems of Ovid. Appletons' classical series. 1882, New York, D. Appleton and Company. xxiv, 238 p. (paraphased with mixed quote [6])</p>
	        <p>[4] More, T. and P. Turner, Utopia. Penguin classics. 1984, London ; New York: Penguin Books. 154 p. (page 53)</p>
	        <p>[5] Marcus, A., M. Hammond, and D. Clay, Meditations. Penguin classics. 2014, London: Penguin Classics, an imprint of Penguin Books. lxi, 351 pages.</p>
	        <p>[6] Vance, A., Elon Musk : Tesla, SpaceX, and the quest for a fantastic future. First edition. ed. 2015, New York, NY: Ecco, an imprint of HarperCollinsPublishers. 392 pages.</p>
	        <p>[7] Budiansky, S., Code Warriors. 2016, New York: Alfred A. Knopf. xxi, 389 pages, 16 unnumbered pages of plates.</p>
				</Panel>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default Album;



// WEBPACK FOOTER //
// ./src/cba/appspec/body/Album.js